module.exports = __webpack_public_path__ + "static/media/next_black.ca1a9abc.svg";